export enum EStatusTextColors {
  WHITE_COLOR_HEX = '#FFFFFF',
  BLACK_COLOR_HEX = '#000000',
}
